module.exports = __webpack_public_path__ + "img/avterracebox07.6993674b.jpg";